import React from 'react';
import { Wallet, ArrowDownLeft, Clock, CheckCircle2, Download, Filter } from 'lucide-react';
const history = [{
  id: 'PO-9901',
  date: 'Oct 14, 2023',
  amount: 4200,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9900',
  date: 'Oct 01, 2023',
  amount: 3150,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9899',
  date: 'Sep 15, 2023',
  amount: 2800,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}];
export function Payouts() {
  return <div className="space-y-6 max-w-[1600px] mx-auto" data-id="element-1199">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1200">
        <div data-id="element-1201">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1202">Partner Payouts</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1203">
            Withdraw your earnings and manage settlement frequency.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1204">
          <ArrowDownLeft size={18} data-id="element-1205" />
          Request Instant Payout
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1206">
        <div className="bg-slate-900 p-6 rounded-lg text-white" data-id="element-1207">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-1208">
            Available for Withdrawal
          </p>
          <h3 className="text-3xl font-bold" data-id="element-1209">$12,450.00</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-indigo-400" data-id="element-1210">
            <Clock size={14} data-id="element-1211" />
            <span data-id="element-1212">Next auto-payout in 3 days</span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1213">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-1214">
            Total Withdrawn (YTD)
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-1215">$84,200.00</h3>
          <p className="mt-4 text-xs font-bold text-emerald-600 flex items-center gap-1" data-id="element-1216">
            <CheckCircle2 size={14} data-id="element-1217" /> 12 Successful Payouts
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1218">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-1219">
            Pending Clearance
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-1220">$5,120.00</h3>
          <div className="mt-4 w-full bg-gray-100 h-1.5 rounded-full overflow-hidden" data-id="element-1221">
            <div className="h-full bg-indigo-600 w-2/3" data-id="element-1222"></div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1223">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between bg-gray-50/50" data-id="element-1224">
          <h3 className="font-bold text-slate-900" data-id="element-1225">Payout History</h3>
          <div className="flex gap-2" data-id="element-1226">
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-1227">
              <Filter size={18} data-id="element-1228" />
            </button>
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-1229">
              <Download size={18} data-id="element-1230" />
            </button>
          </div>
        </div>
        <table className="w-full text-left border-collapse" data-id="element-1231">
          <thead data-id="element-1232">
            <tr className="text-[10px] font-bold uppercase tracking-wider text-gray-400 border-b border-gray-100" data-id="element-1233">
              <th className="px-6 py-4" data-id="element-1234">Payout ID</th>
              <th className="px-6 py-4" data-id="element-1235">Date</th>
              <th className="px-6 py-4" data-id="element-1236">Amount</th>
              <th className="px-6 py-4" data-id="element-1237">Method</th>
              <th className="px-6 py-4" data-id="element-1238">Status</th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-1239">
            {history.map(h => <tr key={h.id} className="hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0" data-id="element-1240">
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-1241">{h.id}</td>
                <td className="px-6 py-4 text-gray-500" data-id="element-1242">{h.date}</td>
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-1243">
                  ${h.amount.toLocaleString()}.00
                </td>
                <td className="px-6 py-4 text-gray-500 font-medium" data-id="element-1244">
                  {h.method}
                </td>
                <td className="px-6 py-4" data-id="element-1245">
                  <span className="px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-50 text-emerald-600" data-id="element-1246">
                    {h.status}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}